var exports = {
  "m": "transferWarningFlash__xcU4Ye",
  "p": "noResultsContainer__lkqlf4",
};

module.exports = exports;
